/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ServiceEventsService {
  /** @summary Create */
  createServiceEvent: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateServiceEventBody, CreateServiceEventParameters, TMeta, TSignal>,
      client?: (
        schema: CreateServiceEventSchema,
        options: ServiceOperationMutationFnOptions<CreateServiceEventBody, CreateServiceEventParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateServiceEventData, CreateServiceEventError>>
    ): Promise<RequestFnResponse<CreateServiceEventData, CreateServiceEventError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateServiceEventParameters> | void
    ): ServiceOperationMutationKey<CreateServiceEventSchema, CreateServiceEventParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.createServiceEvent.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.createServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateServiceEventBody, TContext = unknown>(
      parameters: DeepReadonly<CreateServiceEventParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateServiceEventSchema,
        CreateServiceEventData,
        CreateServiceEventParameters,
        TVariables,
        OperationError<CreateServiceEventError>,
        TContext
      >
    ): UseMutationResult<CreateServiceEventData, OperationError<CreateServiceEventError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.createServiceEvent.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.createServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateServiceEventBody, CreateServiceEventParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateServiceEventSchema,
        CreateServiceEventData,
        CreateServiceEventParameters,
        TVariables,
        OperationError<CreateServiceEventError>,
        TContext
      >
    ): UseMutationResult<CreateServiceEventData, OperationError<CreateServiceEventError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createServiceEventTotal = qraft.serviceEventsService.createServiceEvent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createServiceEventTotal = qraft.serviceEventsService.createServiceEvent.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateServiceEventBody,
            CreateServiceEventData,
            CreateServiceEventParameters,
            OperationError<CreateServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceEventSchema,
            CreateServiceEventBody,
            CreateServiceEventData,
            CreateServiceEventParameters,
            OperationError<CreateServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createServiceEventPendingMutationVariables = qraft.serviceEventsService.createServiceEvent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createServiceEventMutationData = qraft.serviceEventsService.createServiceEvent.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateServiceEventData,
        OperationError<CreateServiceEventError>,
        MutationVariables<CreateServiceEventBody, CreateServiceEventParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateServiceEventBody,
            CreateServiceEventData,
            CreateServiceEventParameters,
            OperationError<CreateServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceEventSchema,
            CreateServiceEventBody,
            CreateServiceEventData,
            CreateServiceEventParameters,
            OperationError<CreateServiceEventError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateServiceEventData,
          OperationError<CreateServiceEventError>,
          MutationVariables<CreateServiceEventBody, CreateServiceEventParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateServiceEventBody,
            CreateServiceEventData,
            CreateServiceEventParameters,
            OperationError<CreateServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceEventSchema,
            CreateServiceEventBody,
            CreateServiceEventData,
            CreateServiceEventParameters,
            OperationError<CreateServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventsService.createServiceEvent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventsService.createServiceEvent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateServiceEventBody,
              CreateServiceEventData,
              CreateServiceEventParameters,
              OperationError<CreateServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServiceEventSchema,
              CreateServiceEventBody,
              CreateServiceEventData,
              CreateServiceEventParameters,
              OperationError<CreateServiceEventError>,
              TContext
            >
      ):
        | Mutation<
            CreateServiceEventData,
            CreateServiceEventError,
            MutationVariables<CreateServiceEventBody, CreateServiceEventParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateServiceEventBody,
              CreateServiceEventData,
              CreateServiceEventParameters,
              OperationError<CreateServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServiceEventSchema,
              CreateServiceEventBody,
              CreateServiceEventData,
              CreateServiceEventParameters,
              OperationError<CreateServiceEventError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateServiceEventData,
          CreateServiceEventError,
          MutationVariables<CreateServiceEventBody, CreateServiceEventParameters>,
          TContext
        >
      >;
    };
    schema: CreateServiceEventSchema;
    types: {
      parameters: CreateServiceEventParameters;
      data: CreateServiceEventData;
      error: CreateServiceEventError;
      body: CreateServiceEventBody;
    };
  };
  /**
   * @summary Search Service Events
   * @description Search service events with optional filters.
   */
  searchServiceEvents: {
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<SearchServiceEventsParameters, TMeta, TSignal> | void),
      client?: (
        schema: SearchServiceEventsSchema,
        options: {
          parameters: SearchServiceEventsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<SearchServiceEventsData, SearchServiceEventsError>>
    ): Promise<RequestFnResponse<SearchServiceEventsData, SearchServiceEventsError>>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    getQueryKey(
      parameters: DeepReadonly<SearchServiceEventsParameters> | void
    ): ServiceOperationQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search Service Events
     * @description Search service events with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceEventsService.searchServiceEvents.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceEventsService.searchServiceEvents.useQuery({
     *     query: {
     *         event_date_gte: eventDateGte
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchServiceEventsData>(
      parameters:
        | ServiceOperationQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        | (DeepReadonly<SearchServiceEventsParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          SearchServiceEventsData,
          SearchServiceEventsError,
          TData,
          ServiceOperationQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<SearchServiceEventsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search Service Events
     * @description Search service events with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceEventsService.searchServiceEvents.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceEventsService.searchServiceEvents.useQuery({
     *     query: {
     *         event_date_gte: eventDateGte
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchServiceEventsData>(
      parameters:
        | ServiceOperationQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        | (DeepReadonly<SearchServiceEventsParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          SearchServiceEventsData,
          SearchServiceEventsError,
          TData,
          ServiceOperationQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<SearchServiceEventsError>>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<SearchServiceEventsParameters> | void
    ): ServiceOperationInfiniteQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search Service Events
     * @description Search service events with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceEventsService.searchServiceEvents.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             event_date_gte: initialEventDateGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchServiceEventsParameters,
      TQueryFnData = SearchServiceEventsData,
      TData = OperationInfiniteData<TQueryFnData, SearchServiceEventsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        | (DeepReadonly<SearchServiceEventsParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchServiceEventsError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<SearchServiceEventsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search Service Events
     * @description Search service events with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceEventsService.searchServiceEvents.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             event_date_gte: initialEventDateGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchServiceEventsParameters,
      TQueryFnData = SearchServiceEventsData,
      TData = OperationInfiniteData<TQueryFnData, SearchServiceEventsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        | (DeepReadonly<SearchServiceEventsParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchServiceEventsError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchServiceEventsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<SearchServiceEventsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Search Service Events
     * @description Search service events with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const searchServiceEventsTotal = qraft.serviceEventsService.searchServiceEvents.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const searchServiceEventsByParametersTotal = qraft.serviceEventsService.searchServiceEvents.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             event_date_gte: eventDateGte
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >
        | QueryFiltersByQueryKey<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Search Service Events
     * @description Search service events with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const searchServiceEventsResults = qraft.serviceEventsService.searchServiceEvents.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 event_date_gte: eventDateGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 event_date_gte: eventDateGte2
     *             }
     *         }
     *     ]
     * });
     * searchServiceEventsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const searchServiceEventsCombinedResults = qraft.serviceEventsService.searchServiceEvents.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 event_date_gte: eventDateGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 event_date_gte: eventDateGte2
     *             }
     *         }
     *     ]
     * });
     * searchServiceEventsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          SearchServiceEventsSchema,
          SearchServiceEventsParameters,
          SearchServiceEventsData,
          SearchServiceEventsError
        >
      >,
      TCombinedResult = Array<UseQueryResult<SearchServiceEventsData, SearchServiceEventsError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<SearchServiceEventsData, SearchServiceEventsError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Search Service Events
     * @description Search service events with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.serviceEventsService.searchServiceEvents.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.serviceEventsService.searchServiceEvents.useSuspenseQuery({
     *     query: {
     *         event_date_gte: eventDateGte
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = SearchServiceEventsData>(
      parameters:
        | ServiceOperationQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        | (DeepReadonly<SearchServiceEventsParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          SearchServiceEventsData,
          SearchServiceEventsError,
          TData,
          ServiceOperationQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<SearchServiceEventsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Search Service Events
     * @description Search service events with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceEventsService.searchServiceEvents.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             event_date_gte: initialEventDateGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends SearchServiceEventsParameters, TData = SearchServiceEventsData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        | (DeepReadonly<SearchServiceEventsParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          SearchServiceEventsData,
          SearchServiceEventsError,
          OperationInfiniteData<TData, SearchServiceEventsParameters>,
          ServiceOperationInfiniteQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchServiceEventsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, SearchServiceEventsParameters>,
      OperationError<SearchServiceEventsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Search Service Events
     * @description Search service events with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const searchServiceEventsData = qraft.serviceEventsService.searchServiceEvents.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 event_date_gte: eventDateGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 event_date_gte: eventDateGte2
     *             }
     *         }
     *     ]
     * });
     * searchServiceEventsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const searchServiceEventsCombinedData = qraft.serviceEventsService.searchServiceEvents.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 event_date_gte: eventDateGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 event_date_gte: eventDateGte2
     *             }
     *         }
     *     ]
     * });
     * searchServiceEventsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          SearchServiceEventsSchema,
          SearchServiceEventsParameters,
          SearchServiceEventsData,
          SearchServiceEventsError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<SearchServiceEventsData, SearchServiceEventsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<SearchServiceEventsData, SearchServiceEventsError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchServiceEventsSchema,
        SearchServiceEventsData,
        SearchServiceEventsParameters,
        SearchServiceEventsError
      > | void
    ): Promise<SearchServiceEventsData>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchServiceEventsSchema,
        SearchServiceEventsData,
        SearchServiceEventsParameters,
        SearchServiceEventsError
      > | void
    ): Promise<void>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        SearchServiceEventsSchema,
        SearchServiceEventsData,
        SearchServiceEventsParameters,
        SearchServiceEventsError
      > | void
    ): Promise<SearchServiceEventsData>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    fetchInfiniteQuery<TPageParam extends SearchServiceEventsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchServiceEventsSchema,
        SearchServiceEventsData,
        SearchServiceEventsParameters,
        DeepReadonly<TPageParam>,
        SearchServiceEventsError
      > | void
    ): Promise<OperationInfiniteData<SearchServiceEventsData, SearchServiceEventsParameters>>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    prefetchInfiniteQuery<TPageParam extends SearchServiceEventsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchServiceEventsSchema,
        SearchServiceEventsData,
        SearchServiceEventsParameters,
        DeepReadonly<TPageParam>,
        SearchServiceEventsError
      > | void
    ): Promise<void>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    ensureInfiniteQueryData<TPageParam extends SearchServiceEventsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        SearchServiceEventsSchema,
        SearchServiceEventsData,
        SearchServiceEventsParameters,
        DeepReadonly<TPageParam>,
        SearchServiceEventsError
      > | void
    ): Promise<OperationInfiniteData<SearchServiceEventsData, SearchServiceEventsParameters>>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        | (DeepReadonly<SearchServiceEventsParameters> | void)
    ): SearchServiceEventsData | undefined;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        | (DeepReadonly<SearchServiceEventsParameters> | void)
    ): OperationInfiniteData<SearchServiceEventsData, SearchServiceEventsParameters> | undefined;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >
        | QueryFiltersByQueryKey<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>,
            data: NoInfer<OperationInfiniteData<SearchServiceEventsData, SearchServiceEventsParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>,
            data: SearchServiceEventsData | undefined,
          ]
        >;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        | (DeepReadonly<SearchServiceEventsParameters> | void)
    ): QueryState<SearchServiceEventsData, SearchServiceEventsError> | undefined;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<SearchServiceEventsParameters>
        | ServiceOperationInfiniteQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<SearchServiceEventsData, SearchServiceEventsParameters>,
          SearchServiceEventsError
        >
      | undefined;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<SearchServiceEventsParameters> | undefined)
        | ServiceOperationQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>,
      updater: Updater<
        NoInfer<SearchServiceEventsData> | undefined,
        NoInfer<DeepReadonly<SearchServiceEventsData>> | undefined
      >,
      options?: SetDataOptions
    ): SearchServiceEventsData | undefined;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<SearchServiceEventsParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<SearchServiceEventsSchema, SearchServiceEventsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<SearchServiceEventsData, SearchServiceEventsParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<SearchServiceEventsData, SearchServiceEventsParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<SearchServiceEventsData, SearchServiceEventsParameters> | undefined;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >
        | QueryFiltersByQueryKey<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >,
      updater: Updater<NoInfer<SearchServiceEventsData> | undefined, NoInfer<SearchServiceEventsData> | undefined>,
      options?: SetDataOptions
    ): Array<SearchServiceEventsData | undefined>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        SearchServiceEventsSchema,
        SearchServiceEventsData,
        TInfinite,
        SearchServiceEventsParameters,
        SearchServiceEventsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >
        | QueryFiltersByQueryKey<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >
        | QueryFiltersByQueryKey<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >
        | QueryFiltersByQueryKey<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >
    ): void;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >
        | QueryFiltersByQueryKey<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Search Service Events
     * @description Search service events with optional filters.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >
        | QueryFiltersByQueryKey<
            SearchServiceEventsSchema,
            SearchServiceEventsData,
            TInfinite,
            SearchServiceEventsParameters,
            SearchServiceEventsError
          >
    ): number;
    schema: SearchServiceEventsSchema;
    types: {
      parameters: SearchServiceEventsParameters;
      data: SearchServiceEventsData;
      error: SearchServiceEventsError;
    };
  };
  /** @summary Update */
  updateServiceEvent: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<UpdateServiceEventBody, UpdateServiceEventParameters, TMeta, TSignal>,
      client?: (
        schema: UpdateServiceEventSchema,
        options: ServiceOperationMutationFnOptions<UpdateServiceEventBody, UpdateServiceEventParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<UpdateServiceEventData, UpdateServiceEventError>>
    ): Promise<RequestFnResponse<UpdateServiceEventData, UpdateServiceEventError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateServiceEventParameters> | void
    ): ServiceOperationMutationKey<UpdateServiceEventSchema, UpdateServiceEventParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.updateServiceEvent.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.updateServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateServiceEventBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateServiceEventParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateServiceEventSchema,
        UpdateServiceEventData,
        UpdateServiceEventParameters,
        TVariables,
        OperationError<UpdateServiceEventError>,
        TContext
      >
    ): UseMutationResult<UpdateServiceEventData, OperationError<UpdateServiceEventError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.updateServiceEvent.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.updateServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateServiceEventBody, UpdateServiceEventParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateServiceEventSchema,
        UpdateServiceEventData,
        UpdateServiceEventParameters,
        TVariables,
        OperationError<UpdateServiceEventError>,
        TContext
      >
    ): UseMutationResult<UpdateServiceEventData, OperationError<UpdateServiceEventError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateServiceEventTotal = qraft.serviceEventsService.updateServiceEvent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateServiceEventTotal = qraft.serviceEventsService.updateServiceEvent.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceEventBody,
            UpdateServiceEventData,
            UpdateServiceEventParameters,
            OperationError<UpdateServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceEventSchema,
            UpdateServiceEventBody,
            UpdateServiceEventData,
            UpdateServiceEventParameters,
            OperationError<UpdateServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateServiceEventPendingMutationVariables = qraft.serviceEventsService.updateServiceEvent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateServiceEventMutationData = qraft.serviceEventsService.updateServiceEvent.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateServiceEventData,
        OperationError<UpdateServiceEventError>,
        MutationVariables<UpdateServiceEventBody, UpdateServiceEventParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceEventBody,
            UpdateServiceEventData,
            UpdateServiceEventParameters,
            OperationError<UpdateServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceEventSchema,
            UpdateServiceEventBody,
            UpdateServiceEventData,
            UpdateServiceEventParameters,
            OperationError<UpdateServiceEventError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateServiceEventData,
          OperationError<UpdateServiceEventError>,
          MutationVariables<UpdateServiceEventBody, UpdateServiceEventParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceEventBody,
            UpdateServiceEventData,
            UpdateServiceEventParameters,
            OperationError<UpdateServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceEventSchema,
            UpdateServiceEventBody,
            UpdateServiceEventData,
            UpdateServiceEventParameters,
            OperationError<UpdateServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventsService.updateServiceEvent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventsService.updateServiceEvent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateServiceEventBody,
              UpdateServiceEventData,
              UpdateServiceEventParameters,
              OperationError<UpdateServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServiceEventSchema,
              UpdateServiceEventBody,
              UpdateServiceEventData,
              UpdateServiceEventParameters,
              OperationError<UpdateServiceEventError>,
              TContext
            >
      ):
        | Mutation<
            UpdateServiceEventData,
            UpdateServiceEventError,
            MutationVariables<UpdateServiceEventBody, UpdateServiceEventParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateServiceEventBody,
              UpdateServiceEventData,
              UpdateServiceEventParameters,
              OperationError<UpdateServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServiceEventSchema,
              UpdateServiceEventBody,
              UpdateServiceEventData,
              UpdateServiceEventParameters,
              OperationError<UpdateServiceEventError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateServiceEventData,
          UpdateServiceEventError,
          MutationVariables<UpdateServiceEventBody, UpdateServiceEventParameters>,
          TContext
        >
      >;
    };
    schema: UpdateServiceEventSchema;
    types: {
      parameters: UpdateServiceEventParameters;
      data: UpdateServiceEventData;
      error: UpdateServiceEventError;
      body: UpdateServiceEventBody;
    };
  };
  /** @summary Reschedule */
  rescheduleServiceEvent: {
    /** @summary Reschedule */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        RescheduleServiceEventBody,
        RescheduleServiceEventParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: RescheduleServiceEventSchema,
        options: ServiceOperationMutationFnOptions<
          RescheduleServiceEventBody,
          RescheduleServiceEventParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<RescheduleServiceEventData, RescheduleServiceEventError>>
    ): Promise<RequestFnResponse<RescheduleServiceEventData, RescheduleServiceEventError>>;
    /** @summary Reschedule */
    getMutationKey(
      parameters: DeepReadonly<RescheduleServiceEventParameters> | void
    ): ServiceOperationMutationKey<RescheduleServiceEventSchema, RescheduleServiceEventParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Reschedule
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.rescheduleServiceEvent.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.rescheduleServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends RescheduleServiceEventBody, TContext = unknown>(
      parameters: DeepReadonly<RescheduleServiceEventParameters>,
      options?: ServiceOperationUseMutationOptions<
        RescheduleServiceEventSchema,
        RescheduleServiceEventData,
        RescheduleServiceEventParameters,
        TVariables,
        OperationError<RescheduleServiceEventError>,
        TContext
      >
    ): UseMutationResult<RescheduleServiceEventData, OperationError<RescheduleServiceEventError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Reschedule
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.rescheduleServiceEvent.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.rescheduleServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<RescheduleServiceEventBody, RescheduleServiceEventParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RescheduleServiceEventSchema,
        RescheduleServiceEventData,
        RescheduleServiceEventParameters,
        TVariables,
        OperationError<RescheduleServiceEventError>,
        TContext
      >
    ): UseMutationResult<RescheduleServiceEventData, OperationError<RescheduleServiceEventError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Reschedule
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const rescheduleServiceEventTotal = qraft.serviceEventsService.rescheduleServiceEvent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const rescheduleServiceEventTotal = qraft.serviceEventsService.rescheduleServiceEvent.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RescheduleServiceEventBody,
            RescheduleServiceEventData,
            RescheduleServiceEventParameters,
            OperationError<RescheduleServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RescheduleServiceEventSchema,
            RescheduleServiceEventBody,
            RescheduleServiceEventData,
            RescheduleServiceEventParameters,
            OperationError<RescheduleServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Reschedule
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const rescheduleServiceEventPendingMutationVariables = qraft.serviceEventsService.rescheduleServiceEvent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const rescheduleServiceEventMutationData = qraft.serviceEventsService.rescheduleServiceEvent.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RescheduleServiceEventData,
        OperationError<RescheduleServiceEventError>,
        MutationVariables<RescheduleServiceEventBody, RescheduleServiceEventParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RescheduleServiceEventBody,
            RescheduleServiceEventData,
            RescheduleServiceEventParameters,
            OperationError<RescheduleServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RescheduleServiceEventSchema,
            RescheduleServiceEventBody,
            RescheduleServiceEventData,
            RescheduleServiceEventParameters,
            OperationError<RescheduleServiceEventError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RescheduleServiceEventData,
          OperationError<RescheduleServiceEventError>,
          MutationVariables<RescheduleServiceEventBody, RescheduleServiceEventParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Reschedule */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RescheduleServiceEventBody,
            RescheduleServiceEventData,
            RescheduleServiceEventParameters,
            OperationError<RescheduleServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RescheduleServiceEventSchema,
            RescheduleServiceEventBody,
            RescheduleServiceEventData,
            RescheduleServiceEventParameters,
            OperationError<RescheduleServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Reschedule
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventsService.rescheduleServiceEvent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventsService.rescheduleServiceEvent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RescheduleServiceEventBody,
              RescheduleServiceEventData,
              RescheduleServiceEventParameters,
              OperationError<RescheduleServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RescheduleServiceEventSchema,
              RescheduleServiceEventBody,
              RescheduleServiceEventData,
              RescheduleServiceEventParameters,
              OperationError<RescheduleServiceEventError>,
              TContext
            >
      ):
        | Mutation<
            RescheduleServiceEventData,
            RescheduleServiceEventError,
            MutationVariables<RescheduleServiceEventBody, RescheduleServiceEventParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RescheduleServiceEventBody,
              RescheduleServiceEventData,
              RescheduleServiceEventParameters,
              OperationError<RescheduleServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RescheduleServiceEventSchema,
              RescheduleServiceEventBody,
              RescheduleServiceEventData,
              RescheduleServiceEventParameters,
              OperationError<RescheduleServiceEventError>,
              TContext
            >
      ): Array<
        Mutation<
          RescheduleServiceEventData,
          RescheduleServiceEventError,
          MutationVariables<RescheduleServiceEventBody, RescheduleServiceEventParameters>,
          TContext
        >
      >;
    };
    schema: RescheduleServiceEventSchema;
    types: {
      parameters: RescheduleServiceEventParameters;
      data: RescheduleServiceEventData;
      error: RescheduleServiceEventError;
      body: RescheduleServiceEventBody;
    };
  };
  /** @summary Cancel */
  cancelServiceEvent: {
    /** @summary Cancel */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CancelServiceEventBody, CancelServiceEventParameters, TMeta, TSignal>,
      client?: (
        schema: CancelServiceEventSchema,
        options: ServiceOperationMutationFnOptions<CancelServiceEventBody, CancelServiceEventParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CancelServiceEventData, CancelServiceEventError>>
    ): Promise<RequestFnResponse<CancelServiceEventData, CancelServiceEventError>>;
    /** @summary Cancel */
    getMutationKey(
      parameters: DeepReadonly<CancelServiceEventParameters> | void
    ): ServiceOperationMutationKey<CancelServiceEventSchema, CancelServiceEventParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Cancel
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.cancelServiceEvent.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.cancelServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends CancelServiceEventBody, TContext = unknown>(
      parameters: DeepReadonly<CancelServiceEventParameters>,
      options?: ServiceOperationUseMutationOptions<
        CancelServiceEventSchema,
        CancelServiceEventData,
        CancelServiceEventParameters,
        TVariables,
        OperationError<CancelServiceEventError>,
        TContext
      >
    ): UseMutationResult<CancelServiceEventData, OperationError<CancelServiceEventError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Cancel
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.cancelServiceEvent.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.cancelServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CancelServiceEventBody, CancelServiceEventParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CancelServiceEventSchema,
        CancelServiceEventData,
        CancelServiceEventParameters,
        TVariables,
        OperationError<CancelServiceEventError>,
        TContext
      >
    ): UseMutationResult<CancelServiceEventData, OperationError<CancelServiceEventError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Cancel
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const cancelServiceEventTotal = qraft.serviceEventsService.cancelServiceEvent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const cancelServiceEventTotal = qraft.serviceEventsService.cancelServiceEvent.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CancelServiceEventBody,
            CancelServiceEventData,
            CancelServiceEventParameters,
            OperationError<CancelServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelServiceEventSchema,
            CancelServiceEventBody,
            CancelServiceEventData,
            CancelServiceEventParameters,
            OperationError<CancelServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Cancel
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const cancelServiceEventPendingMutationVariables = qraft.serviceEventsService.cancelServiceEvent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const cancelServiceEventMutationData = qraft.serviceEventsService.cancelServiceEvent.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CancelServiceEventData,
        OperationError<CancelServiceEventError>,
        MutationVariables<CancelServiceEventBody, CancelServiceEventParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CancelServiceEventBody,
            CancelServiceEventData,
            CancelServiceEventParameters,
            OperationError<CancelServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelServiceEventSchema,
            CancelServiceEventBody,
            CancelServiceEventData,
            CancelServiceEventParameters,
            OperationError<CancelServiceEventError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CancelServiceEventData,
          OperationError<CancelServiceEventError>,
          MutationVariables<CancelServiceEventBody, CancelServiceEventParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Cancel */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CancelServiceEventBody,
            CancelServiceEventData,
            CancelServiceEventParameters,
            OperationError<CancelServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelServiceEventSchema,
            CancelServiceEventBody,
            CancelServiceEventData,
            CancelServiceEventParameters,
            OperationError<CancelServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Cancel
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventsService.cancelServiceEvent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventsService.cancelServiceEvent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CancelServiceEventBody,
              CancelServiceEventData,
              CancelServiceEventParameters,
              OperationError<CancelServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CancelServiceEventSchema,
              CancelServiceEventBody,
              CancelServiceEventData,
              CancelServiceEventParameters,
              OperationError<CancelServiceEventError>,
              TContext
            >
      ):
        | Mutation<
            CancelServiceEventData,
            CancelServiceEventError,
            MutationVariables<CancelServiceEventBody, CancelServiceEventParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CancelServiceEventBody,
              CancelServiceEventData,
              CancelServiceEventParameters,
              OperationError<CancelServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CancelServiceEventSchema,
              CancelServiceEventBody,
              CancelServiceEventData,
              CancelServiceEventParameters,
              OperationError<CancelServiceEventError>,
              TContext
            >
      ): Array<
        Mutation<
          CancelServiceEventData,
          CancelServiceEventError,
          MutationVariables<CancelServiceEventBody, CancelServiceEventParameters>,
          TContext
        >
      >;
    };
    schema: CancelServiceEventSchema;
    types: {
      parameters: CancelServiceEventParameters;
      data: CancelServiceEventData;
      error: CancelServiceEventError;
      body: CancelServiceEventBody;
    };
  };
  /** @summary Complete */
  completeServiceEvent: {
    /** @summary Complete */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CompleteServiceEventBody,
        CompleteServiceEventParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CompleteServiceEventSchema,
        options: ServiceOperationMutationFnOptions<
          CompleteServiceEventBody,
          CompleteServiceEventParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CompleteServiceEventData, CompleteServiceEventError>>
    ): Promise<RequestFnResponse<CompleteServiceEventData, CompleteServiceEventError>>;
    /** @summary Complete */
    getMutationKey(
      parameters: DeepReadonly<CompleteServiceEventParameters> | void
    ): ServiceOperationMutationKey<CompleteServiceEventSchema, CompleteServiceEventParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Complete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.completeServiceEvent.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.completeServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends CompleteServiceEventBody, TContext = unknown>(
      parameters: DeepReadonly<CompleteServiceEventParameters>,
      options?: ServiceOperationUseMutationOptions<
        CompleteServiceEventSchema,
        CompleteServiceEventData,
        CompleteServiceEventParameters,
        TVariables,
        OperationError<CompleteServiceEventError>,
        TContext
      >
    ): UseMutationResult<
      CompleteServiceEventData,
      OperationError<CompleteServiceEventError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Complete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.completeServiceEvent.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.completeServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CompleteServiceEventBody, CompleteServiceEventParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CompleteServiceEventSchema,
        CompleteServiceEventData,
        CompleteServiceEventParameters,
        TVariables,
        OperationError<CompleteServiceEventError>,
        TContext
      >
    ): UseMutationResult<CompleteServiceEventData, OperationError<CompleteServiceEventError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Complete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const completeServiceEventTotal = qraft.serviceEventsService.completeServiceEvent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const completeServiceEventTotal = qraft.serviceEventsService.completeServiceEvent.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CompleteServiceEventBody,
            CompleteServiceEventData,
            CompleteServiceEventParameters,
            OperationError<CompleteServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CompleteServiceEventSchema,
            CompleteServiceEventBody,
            CompleteServiceEventData,
            CompleteServiceEventParameters,
            OperationError<CompleteServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Complete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const completeServiceEventPendingMutationVariables = qraft.serviceEventsService.completeServiceEvent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const completeServiceEventMutationData = qraft.serviceEventsService.completeServiceEvent.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CompleteServiceEventData,
        OperationError<CompleteServiceEventError>,
        MutationVariables<CompleteServiceEventBody, CompleteServiceEventParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CompleteServiceEventBody,
            CompleteServiceEventData,
            CompleteServiceEventParameters,
            OperationError<CompleteServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CompleteServiceEventSchema,
            CompleteServiceEventBody,
            CompleteServiceEventData,
            CompleteServiceEventParameters,
            OperationError<CompleteServiceEventError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CompleteServiceEventData,
          OperationError<CompleteServiceEventError>,
          MutationVariables<CompleteServiceEventBody, CompleteServiceEventParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Complete */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CompleteServiceEventBody,
            CompleteServiceEventData,
            CompleteServiceEventParameters,
            OperationError<CompleteServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CompleteServiceEventSchema,
            CompleteServiceEventBody,
            CompleteServiceEventData,
            CompleteServiceEventParameters,
            OperationError<CompleteServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Complete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventsService.completeServiceEvent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventsService.completeServiceEvent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CompleteServiceEventBody,
              CompleteServiceEventData,
              CompleteServiceEventParameters,
              OperationError<CompleteServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CompleteServiceEventSchema,
              CompleteServiceEventBody,
              CompleteServiceEventData,
              CompleteServiceEventParameters,
              OperationError<CompleteServiceEventError>,
              TContext
            >
      ):
        | Mutation<
            CompleteServiceEventData,
            CompleteServiceEventError,
            MutationVariables<CompleteServiceEventBody, CompleteServiceEventParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CompleteServiceEventBody,
              CompleteServiceEventData,
              CompleteServiceEventParameters,
              OperationError<CompleteServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CompleteServiceEventSchema,
              CompleteServiceEventBody,
              CompleteServiceEventData,
              CompleteServiceEventParameters,
              OperationError<CompleteServiceEventError>,
              TContext
            >
      ): Array<
        Mutation<
          CompleteServiceEventData,
          CompleteServiceEventError,
          MutationVariables<CompleteServiceEventBody, CompleteServiceEventParameters>,
          TContext
        >
      >;
    };
    schema: CompleteServiceEventSchema;
    types: {
      parameters: CompleteServiceEventParameters;
      data: CompleteServiceEventData;
      error: CompleteServiceEventError;
      body: CompleteServiceEventBody;
    };
  };
}
/** @summary Create */
export const createServiceEvent = {
  schema: {
    method: 'post',
    url: '/service_events/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateServiceEventSchema;
  [QraftServiceOperationsToken]: ServiceEventsService['createServiceEvent'];
};
/**
 * @summary Search Service Events
 * @description Search service events with optional filters.
 */
export const searchServiceEvents = {
  schema: {
    method: 'get',
    url: '/service_events/search',
    security: ['HTTPBearer'],
  },
} as {
  schema: SearchServiceEventsSchema;
  [QraftServiceOperationsToken]: ServiceEventsService['searchServiceEvents'];
};
/** @summary Update */
export const updateServiceEvent = {
  schema: {
    method: 'patch',
    url: '/service_events/{service_event_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateServiceEventSchema;
  [QraftServiceOperationsToken]: ServiceEventsService['updateServiceEvent'];
};
/** @summary Reschedule */
export const rescheduleServiceEvent = {
  schema: {
    method: 'post',
    url: '/service_events/{service_event_id}/reschedule',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: RescheduleServiceEventSchema;
  [QraftServiceOperationsToken]: ServiceEventsService['rescheduleServiceEvent'];
};
/** @summary Cancel */
export const cancelServiceEvent = {
  schema: {
    method: 'post',
    url: '/service_events/{service_event_id}/cancel',
    security: ['HTTPBearer'],
  },
} as {
  schema: CancelServiceEventSchema;
  [QraftServiceOperationsToken]: ServiceEventsService['cancelServiceEvent'];
};
/** @summary Complete */
export const completeServiceEvent = {
  schema: {
    method: 'post',
    url: '/service_events/{service_event_id}/complete',
    security: ['HTTPBearer'],
  },
} as {
  schema: CompleteServiceEventSchema;
  [QraftServiceOperationsToken]: ServiceEventsService['completeServiceEvent'];
};
export const serviceEventsService = {
  createServiceEvent,
  searchServiceEvents,
  updateServiceEvent,
  rescheduleServiceEvent,
  cancelServiceEvent,
  completeServiceEvent,
} as const;
type CreateServiceEventSchema = {
  method: 'post';
  url: '/service_events/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateServiceEventParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateServiceEventData = paths['/service_events/']['post']['responses']['200']['content']['application/json'];
type CreateServiceEventError = paths['/service_events/']['post']['responses']['422']['content']['application/json'];
type CreateServiceEventBody = paths['/service_events/']['post']['requestBody']['content']['application/json'];
type SearchServiceEventsSchema = {
  method: 'get';
  url: '/service_events/search';
  security: ['HTTPBearer'];
};
type SearchServiceEventsParameters = paths['/service_events/search']['get']['parameters'];
type SearchServiceEventsData =
  paths['/service_events/search']['get']['responses']['200']['content']['application/json'];
type SearchServiceEventsError =
  paths['/service_events/search']['get']['responses']['422']['content']['application/json'];
type UpdateServiceEventSchema = {
  method: 'patch';
  url: '/service_events/{service_event_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateServiceEventParameters = paths['/service_events/{service_event_id}']['patch']['parameters'];
type UpdateServiceEventData =
  paths['/service_events/{service_event_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateServiceEventError =
  paths['/service_events/{service_event_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateServiceEventBody =
  paths['/service_events/{service_event_id}']['patch']['requestBody']['content']['application/json'];
type RescheduleServiceEventSchema = {
  method: 'post';
  url: '/service_events/{service_event_id}/reschedule';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type RescheduleServiceEventParameters = paths['/service_events/{service_event_id}/reschedule']['post']['parameters'];
type RescheduleServiceEventData =
  paths['/service_events/{service_event_id}/reschedule']['post']['responses']['200']['content']['application/json'];
type RescheduleServiceEventError =
  paths['/service_events/{service_event_id}/reschedule']['post']['responses']['422']['content']['application/json'];
type RescheduleServiceEventBody =
  paths['/service_events/{service_event_id}/reschedule']['post']['requestBody']['content']['application/json'];
type CancelServiceEventSchema = {
  method: 'post';
  url: '/service_events/{service_event_id}/cancel';
  security: ['HTTPBearer'];
};
type CancelServiceEventParameters = paths['/service_events/{service_event_id}/cancel']['post']['parameters'];
type CancelServiceEventData =
  paths['/service_events/{service_event_id}/cancel']['post']['responses']['200']['content']['application/json'];
type CancelServiceEventError =
  paths['/service_events/{service_event_id}/cancel']['post']['responses']['422']['content']['application/json'];
type CancelServiceEventBody = undefined;
type CompleteServiceEventSchema = {
  method: 'post';
  url: '/service_events/{service_event_id}/complete';
  security: ['HTTPBearer'];
};
type CompleteServiceEventParameters = paths['/service_events/{service_event_id}/complete']['post']['parameters'];
type CompleteServiceEventData =
  paths['/service_events/{service_event_id}/complete']['post']['responses']['200']['content']['application/json'];
type CompleteServiceEventError =
  paths['/service_events/{service_event_id}/complete']['post']['responses']['422']['content']['application/json'];
type CompleteServiceEventBody = undefined;
